export default "__VITE_ASSET__dc19bb09__"